'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseContainerData = exports.clearState = exports.setState = exports.getState = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _lodash = require('lodash.uniqby');

var _lodash2 = _interopRequireDefault(_lodash);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _state = require('state');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ponyfill for Object.entries
var entries = function entries(obj) {
  var ownProps = Object.keys(obj);
  var i = ownProps.length;
  var resArray = new Array(i); // preallocate the Array

  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }

  return resArray;
}; /* eslint-disable no-unused-vars */
var getState = function getState(key) {
  if (key instanceof Element) {
    var id = (0, _Helpers.getContainer)({ self: key }).dataset.containerId;


    return getState(id);
  }

  var cart = _state.state.cart,
      states = (0, _objectWithoutProperties3.default)(_state.state, ['cart']);

  var ids = entries(states).reduce(function (allState, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        name = _ref2[0],
        values = _ref2[1];

    return Object.assign({}, allState, values);
  }, {});

  if (_state.state[key]) {
    return _state.state[key];
  } else if (ids[key]) {
    return ids[key];
  }

  // return state;
  return undefined;
};

exports.getState = getState;
var setState = exports.setState = function setState(data) {
  var container = data.container;
  var change = data.change;
  var id = data.id;

  if (!container) return;

  delete data.container;
  delete data.change;
  delete data.id;

  var oldState = id ? _state.state[container][id] : _state.state[container];

  var newState = Array.isArray(data) ? [].concat((0, _toConsumableArray3.default)(data)) : Object.assign({}, oldState, data);

  if (id) {
    _state.state[container][id] = newState;
  } else {
    _state.state[container] = newState;
  }

  var topic = _Constants2.default.state + '.' + (0, _Helpers.constCase)(change) + '.' + (0, _Helpers.constCase)(container);

  PubSub.publish(topic, { id: id, data: data, state: newState });
};

var clearState = function clearState(key) {
  var cart = _state.state.cart,
      states = (0, _objectWithoutProperties3.default)(_state.state, ['cart']);

  var _ref3 = Object.entries(states).find(function (_ref5) {
    var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
        name = _ref6[0],
        values = _ref6[1];

    return Object.keys(values).includes(key);
  }) || [],
      _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
      group = _ref4[0];

  if (_state.state[key]) {
    _state.state[key] = {};
  } else if (group !== undefined) {
    delete _state.state[group][key];
  }

  return _state.state;
};

exports.clearState = clearState;
var parseContainerData = exports.parseContainerData = function parseContainerData(container) {
  return $(_Dom2.default.shopifyData, container).get().reduce(function (containerData, json) {
    try {
      var _ref7;

      var _JSON$parse = JSON.parse(json.text),
          data = _JSON$parse.data;

      var type = json.dataset.fromShopify;


      if (type === 'product') {
        return Object.assign({}, containerData, (0, _defineProperty3.default)({}, type, data));
      }

      var typeData = containerData[type] || [];

      var combinedData = [].concat((0, _toConsumableArray3.default)(typeData), [data]);
      var flatData = (_ref7 = []).concat.apply(_ref7, (0, _toConsumableArray3.default)(combinedData));

      var newData = (0, _lodash2.default)(flatData, '_id');

      return Object.assign({}, containerData, (0, _defineProperty3.default)({}, type, newData));
    } catch (error) {
      console.log(json.text);
      console.log(error);
    }
  }, {});
};